<template>
  <el-row class="row-btns" :class="{'fixed': fixed, 'closed': closed}">
    <!-- 展开收缩 -->
    <div v-if="fixed" class="poa _icon" @click="closed = !closed">
      <i :class="{'el-icon-caret-bottom': !closed, 'el-icon-caret-top': closed}"></i>
      <span class="_text">{{closed ? '显示' : '隐藏'}}</span>
    </div>
    <template v-for="name in newVisibles">
      <!-- 带弹框功能的按钮 -->
      <!-- 2018-9-25 14:30:55 暂时把confirm-button屏蔽掉，改成弹框提示 -->
      <confirm-button class="row-button" v-if="btnConfigs[name] && btnConfigs[name].confirm2" :key="name" :item="btnConfigs[name]" :scope="scope"></confirm-button>
      <!-- 2018-7-12 16:56:18 加入自定义插槽功能 -->
      <div v-else-if="btnConfigs[name] && btnConfigs[name].slot" class="row-button">
        <slot :name="btnConfigs[name].slot">
          自定义内容
        </slot>
      </div>
      <!-- 常规按钮组 -->
      <el-button
        class="row-button"
        v-else
        :key="name + 1"
        :type="btnConfigs[name].type"
        v-bind="btnConfigs[name].props"
        @click="btnConfigs[name].onClick && btnConfigs[name].onClick(btnConfigs[name], scope, $event)"
        >
        {{btnConfigs[name].text}}
        <!-- 2018-5-26 16:21:11 增加工具提示功能 btns[name].tooltip可以为string/object-->
        <el-tooltip popper-class="table-tooltip-box" effect="light"
          v-if="btnConfigs[name].tooltip"
          :key="name + 2"
          v-bind="btnConfigs[name].tooltip.props"
          :placement="btnConfigs[name].tooltip.placement || 'right'"
        >
          <div slot="content">
            <slot :name="'tooltip-' + name">
              {{typeof btnConfigs[name].tooltip === 'string' ? btnConfigs[name].tooltip : btnConfigs[name].tooltip.content}}
            </slot>
          </div>
          <i class="el-icon-question button-tooltip"></i>
        </el-tooltip>
      </el-button>
    </template>
    <el-dropdown v-if="multiSwitch && visibles.length > 3" placement="bottom">
      <el-button type="primary" :plain="false" style="margin-left: 8px;">
        更多条件<i class="el-icon-arrow-down el-icon--right"></i>
      </el-button>
      <el-dropdown-menu slot="dropdown">
        <template v-for="name in moreBtnsGroup" >
          <el-dropdown-item :key="name" v-if="btnConfigs[name] && btnConfigs[name].slot">
            <slot :name="btnConfigs[name].slot">
              自定义内容
            </slot>
          </el-dropdown-item>
          <el-dropdown-item :key="name+1">
            <div v-bind="btnConfigs[name].props" @click="btnConfigs[name].onClick && btnConfigs[name].onClick(btnConfigs[name], scope, $event)">
              {{btnConfigs[name].text}}
              <el-tooltip popper-class="table-tooltip-box" effect="light"
                v-if="btnConfigs[name].tooltip"
                :key="name + 2"
                v-bind="btnConfigs[name].tooltip.props"
                :placement="btnConfigs[name].tooltip.placement || 'right'"
              >
                <div slot="content">
                  <slot :name="'tooltip-' + name">
                    {{typeof btnConfigs[name].tooltip === 'string' ? btnConfigs[name].tooltip : btnConfigs[name].tooltip.content}}
                  </slot>
                </div>
                <i class="el-icon-question button-tooltip"></i>
              </el-tooltip>
            </div>
          </el-dropdown-item>
        </template>
      </el-dropdown-menu>
    </el-dropdown>
  </el-row>
</template>

<script>
import {
  deepCopy
} from "../../utils";
import confirmButton from './confirm-button'
export default {
  name: 'RowBtns',
  components: {
    confirmButton
  },
  config: {},
  props: {
    btns: {
      type: Object,
      default: () => {
        return {}
      }
    },
    visibles: {
      type: Array,
      default: () => {
        return []
      }
    },
    fixed: {
      type: Boolean,
      default: false
    },
    multiSwitch: {
      type: Boolean,
      default: false
    },
    size: String,
    scope: null
  },
  watch: {
    btns: {
      deep: true,
      immediate: true,
      handler () {
        const defaultConfig = this.$options.config.default
        let btnConfigs = {}
        for (const [btnName, btnConfig] of Object.entries(this.btns)) {
          let btn = btnConfigs[btnName] = deepCopy(btnConfig)
          // 2018-9-25 14:36:14 内置弹框确认功能
          btn.onClick = btnConfig.confirm ? (btn, scope, $event) => {
            this.$confirm(btnConfig.confirm).then(() => {
              btnConfig.onClick && btnConfig.onClick(btn, scope, $event)
            }, () => {
              btnConfig.onCancel && btnConfig.onCancel(btn, scope, $event)
            })
          } : btnConfig.onClick
          const selfConfig = this.$options.config[btn.text]
          const config = selfConfig || defaultConfig

          if (btn.props) {
            btn.props.size = btn.props.size || this.defaultSize
          } else {
            // 设置全局size
            btn.props = {
              size: this.size,
            }
          }

          if (config) {
            btn.type = btn.type || config.type
            btn.props = Object.assign({}, config.props, btn.props)
          }
        }
        this.btnConfigs = btnConfigs
      }
    },
    visibles: {
      immediate: true,
      handler () {
        let btnGroupA=[],btnGroupB=[]
        let newVisibles = [...this.visibles]
        if ( this.visibles.length > 3 && this.multiSwitch) {
          for(const [idx, value] of Object.entries(this.visibles)) {
            idx < 3 ? btnGroupA.push(value) : btnGroupB.push(value)
          }
        }
        this.newVisibles = btnGroupA.length > 0 ? [...btnGroupA] : [...newVisibles]
        this.moreBtnsGroup = this.multiSwitch && [...btnGroupB]
      }
    }
  },
  data () {
    return {
      newVisibles: [],
      moreBtnsGroup: [],
      btnConfigs: {},
      multiBtnConfigs: {},
      closed: false
    }
  }
}
</script>
